<template>
  <IntroText
    :intro-one="pageItem.ShortText"
    :pageItem="pageItem"
    :showForm =false
    />
  <IntroText
      :intro-one="pageItem.MainText"
      :pageItem="pageItem"
    />
</template>
<script setup>
import IntroText from "@/components/Base/introText.vue";

const props = defineProps({
  pageItem: {
    type: Object,
    default: "",
  },
});
</script>